import { render, staticRenderFns } from "./IntegrationDeliveryDialog.vue?vue&type=template&id=ef28a10e&scoped=true&"
import script from "./IntegrationDeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./IntegrationDeliveryDialog.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDeliveryDialog.vue?vue&type=style&index=0&id=ef28a10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef28a10e",
  null
  
)

export default component.exports